module.exports = __webpack_public_path__ + "static/media/avatar-05@3x.bff26048.png";